var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-form',{on:{"on-save":function($event){return _vm.save()}},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}})}
var staticRenderFns = []

export { render, staticRenderFns }